/* ═══════════════════════════════════════════════════════════════ */
/*  HELPERS                                                       */
/* ═══════════════════════════════════════════════════════════════ */

export const eC = (e: string): string => ({
  claude: "#818cf8", codex: "#34d399", manus: "#00E5FF", guardian: "#a78bfa",
  github: "#d4d4d8", ci: "#38bdf8", dispatcher: "#00E5FF", railway: "#c084fc",
  supabase: "#4ade80", netlify: "#22d3ee", stripe: "#a78bfa", mailgun: "#fb923c",
  cloudflare: "#f6821f",
}[e] || "#71717a");

export const dC = (s: string): string =>
  s === "healthy" || s === "complete" || s === "completed" || s === "ok" ? "var(--green)" :
  s === "running" || s === "warning" || s === "degraded" || s === "awaiting_consent" ? "var(--yellow)" :
  s === "failed" || s === "error" ? "var(--red)" : "var(--text-dim)";

export function timeAgo(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60000) return "just now";
  if (ms < 3600000) return `${Math.floor(ms / 60000)}m ago`;
  if (ms < 86400000) return `${Math.floor(ms / 3600000)}h ago`;
  return `${Math.floor(ms / 86400000)}d ago`;
}

export function formatDuration(ms: number): string {
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.floor(ms / 60000)}m ${Math.floor((ms % 60000) / 1000)}s`;
}
